<template>
  <v-row>
    <v-col :md="9" :sm="9" :xs="12" cols="12">
      <!-- <v-dialog
      v-model="dialogAvisoDesconto"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Aviso
          <v-spacer></v-spacer>
          <v-btn
              icon
              dark
              @click="dialogAvisoDesconto = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          De acordo com o artigo 13 do Refis, terá 70% de desconto em multas
          cometidas até 31/10/2023.
        </v-card-text>
      </v-card>
    </v-dialog> -->

      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Autos de Infração</v-card-title>
        <v-card-text class="app-card-content">

          <v-text-field
            class="search-input"
            type="search"
            v-model="table.search"
            append-icon="search"
            label="Digite o que deseja pesquisar ..."
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="table.headers"
            :items="table.content"
            :search="table.search"
            :loading="table.isLoading"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 30, 50]
            }"
            :items-per-page="5"
            item-key="numeroAitp"
            item-value="numeroAitp"
            :single-select="true"
            show-select
            v-model="autosSelecteds"
          >
            <!-- substitui o checkbox padrao por um radio: so um por vez
                 (single-select) e clicar no marcado desmarca (nao obriga) -->
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-icon
                :color="isSelected ? 'primary' : ''"
                style="cursor: pointer;"
                @click="select(!isSelected)"
              >
                {{
                  isSelected ? "radio_button_checked" : "radio_button_unchecked"
                }}
              </v-icon>
            </template>
            <template v-slot:item.dataLavratura="{ item }">
              <span>{{ item.dataLavratura | date }}</span>
            </template>
            <template v-slot:item.valor="{ item }">
              <span>{{ item.valor | currency }}</span>
            </template>
            <template v-slot:item.desconto="{ item }">
              <span>{{ item.desconto }}</span>
            </template>
            <template v-if="table.isLoading" v-slot:progress>
              <v-progress-linear indeterminate></v-progress-linear>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col :md="3" :sm="3" :xs="12" cols="12">
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Valor</v-card-title>
        <v-card-text class="app-card-content">
          <h4 class="valorTotal">{{ valorTotal | currency }}</h4>
          <v-form
            ref="form"
            v-model="form.valid"
            lazy-validation
            @submit.prevent="onSubmit"
          >
            <div
              v-show="autosSelecteds && autosSelecteds.length && valorTotal > 0"
            >
              <!-- <p class="font-weight-light text-caption red--text text--lighten-1">
                <strong>Atenção!</strong> <br> Os descontos serão aplicados no momento da geração do boleto
              </p> -->
              <v-btn
                depressed
                block
                color="#3eb355"
                type="submit"
                class="white--text"
                :disabled="autosSelecteds.length > 5"
              >Gerar Boleto</v-btn
              >
              <span v-if="autosSelecteds.length > 5" class="invalid-qtd"
              >Selecione apenas 5 extratos por vez</span
              >
              <br />
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                :size="'100px'"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
                class="recaptcha"
                v-if="autosSelecteds.length <= 5"
              ></vue-recaptcha>
              <v-input
                v-model="form.recaptcha"
                :rules="[rules.required]"
              ></v-input>
            </div>
          </v-form>
          <div class="loading" v-if="isLoading">
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <v-dialog v-model="modal.show" width="800">
            <v-card outlined class="app-card" style="margin-bottom:0px;">
              <v-card-title class="app-card-title" primary-title
              >Boleto da Taxa</v-card-title
              >

              <v-card-text class="app-card-content">
                <div style="height: 466px;">
                  <v-alert type="info"
                  >Faça o Download do boleto abaixo.</v-alert
                  >
                  <p>
                    Caso não consiga visualizar o boleto,
                    <a :href="modal.data.daeGerado" target="_blank"
                    >Clique Aqui</a
                    >
                  </p>
                  <iframe
                    :src="modal.data.daeGerado"
                    style="width: 100%; height: 374px;"
                  ></iframe>
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="error" @click="modal.show = false"
                >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AutoInfracaoService from "@/services/auto_infracao.service";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import GlobalStore from "@/store/modules/global";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY, VUE_APP_PDF_URL, VUE_APP_FINANCEIRO_API_URL } from "@/commons/config";
import * as _ from "lodash";

export default {
  name: "ListaAutosInfracaoDividaAtiva",
  components: {
    VueRecaptcha
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      currentTransportadora: null,
      valorTotal: 0,
      table: {
        search: "",
        headers: [
          {
            text: "Número Aitp",
            align: "start",
            sortable: true,
            value: "numeroAitp"
          },
          {
            text: "Placa",
            align: "start",
            sortable: true,
            value: "placa"
          },
          {
            text: "Descrição",
            align: "start",
            sortable: true,
            value: "descricao"
          },
          {
            text: "Data Lavratura",
            align: "start",
            sortable: true,
            value: "dataLavratura"
          },
          {
            text: "Valor",
            align: "start",
            sortable: true,
            value: "valor"
          },
          // {
          //   text: "Desconto",
          //   align: "start",
          //   sortable: true,
          //   value: "desconto"
          // }
        ],
        content: [],
        isLoading: false
      },
      form: {
        taxasAutos: [],
        transportadoraId: null,
        placa: null,
        cnpjTransportadora: null,
        token: null,
        recaptcha: null
      },
      autosSelecteds: [],
      isLoading: false,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      },
      modal: {
        show: false,
        data: {
          daeGerado: null
        }
      },
      // TODO: sempre que mudar o desconto no backend tem que alterar aqui. Pediram eu fiz :|
      // percentualDesconto: Number(70),
      dialogAvisoDesconto: true
    };
  },
  methods: {
    calcDesconto(infracao){
      if(!infracao.valor || !infracao.dataLavratura) { return '-'}

      const dataLavratura = new Date(infracao.dataLavratura)

      // data limite: 31/10/2023
      // obs: em javascript no new Date o mês começa do índice 0-zero
      const dataLimiteDesconto = new Date(2023, 9, 31)

      if(dataLavratura.getTime() > dataLimiteDesconto.getTime()) return '-';

      const calc = Math.round(Number(infracao.valor))
      // const calc = Math.round(Number(infracao.valor) * this.percentualDesconto)/100


      return this.currencyBr(calc)
    },
    currencyBr(number){
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
        .format(number)
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    loadTransportadora() {
      this.currentTransportadora =
        TransportadoraAuthService.currentTransportadoraValue;

      this.form.transportadoraId = this.currentTransportadora.id;
      this.form.cnpjTransportadora = this.currentTransportadora.cnpj;
      this.form.token = this.currentTransportadora.token;
    },
    loadAutosInfracao() {
      this.table.isLoading = true;
      const { cnpj, token, numOrdem } = this.currentTransportadora;
      AutoInfracaoService.loadAutoInfracaoAptosDividaAtiva(
        cnpj,
        token,
        numOrdem
      ).subscribe(
        response => {
          this.table.content = response.map(r=> ({...r, desconto: this.calcDesconto(r)}));
          this.table.isLoading = false;
        },
        error => {
          // GlobalStore.setSnackBar({
          //   show: true,
          //   message: "Erro ao buscar autos de infração",
          //   type: "error"
          // });
          this.table.isLoading = false;
        }
      );
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      const hasAutos = this.form.taxasAutos && this.form.taxasAutos.length;
      const { numOrdem } = this.currentTransportadora;

      if (isValid && hasAutos) {
        this.isLoading = true;
        const {
          taxasAutos,
          transportadoraId,
          placa,
          cnpjTransportadora,
          token,
          recaptcha,
        } = this.form;
        AutoInfracaoService.gerarAutoInfracaoDae(
          cnpjTransportadora,
          taxasAutos,
          transportadoraId,
          placa,
          recaptcha,
          numOrdem
        ).subscribe(
          res => {
            this.isLoading = false;
            this.autosSelecteds = [];
            this.$refs.form.reset();
            this.expiredRecaptcha();
            this.modal.data.daeGerado = `${VUE_APP_FINANCEIRO_API_URL}/api/pdf/detran/dae/${res}`;
            window.open(this.modal.data.daeGerado);
          },
          error => {
            this.isLoading = false;
          }
        );
      } else {
        this.isLoading = false;
      }
    }
  },
  watch: {
    autosSelecteds(newValue, oldValue) {
      // verificação para adicionar apenas 5 extrato por vez
      const autosValidos = newValue.filter(taxa => taxa.valor != null);

      if (autosValidos.length <= 5) {
        if (autosValidos && autosValidos.length) {
          this.form.taxasAutos = autosValidos.map(ta => ta.numeroAitp);
          this.valorTotal = _.sumBy(autosValidos, a => {
            return Number(a.valor);
          });
        } else {
          this.form.taxasAutos = [];
          this.valorTotal = 0;
        }
      }
    }
  },
  mounted() {
    this.loadTransportadora();
    this.loadAutosInfracao();
  }
};
</script>

<style lang="scss" scoped>
.invalid-qtd {
  color: red;
  font-size: 14px;
  display: block;
  margin-top: 10px;
  line-height: 15px;
}
.valorTotal {
  font-weight: bold !important;
  margin: 20px 0px;
}
.recaptcha {
  width: 100%;
  iframe {
    width: 100%;
  }
  > div {
    width: 100% !important;
    > div {
      width: 100% !important;
    }
  }
}
.search-input {
  margin-bottom: 20px;
}
</style>
